module.exports = __webpack_public_path__ + "static/img/Boschsiemens.c8ec88d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Boschsiemens.png
// module id = J6fL
// module chunks = 0